<div class="tw-w-full tw-cursor-pointer" (click)="changeSort()">
  <ng-content></ng-content>
  <span class="tw-ml-1 tw-w-3 tw-h-3 tw-inline-block">
    <sidkik-icon *ngIf="direction === 'asc'" svgIcon="asc"></sidkik-icon>
    <sidkik-icon *ngIf="direction === 'desc'" svgIcon="desc"></sidkik-icon>
  </span>
</div>